import React, { Component } from "react";
import "./Header.scss"

export default class Header extends Component {
  constructor() {
    super()
    this.state = {
      showShareOptions: false,
      isScrolled: false
    }
  }
  componentDidMount() {
    window.addEventListener("scroll", () => {
      this.setState({
        isScrolled: (window.scrollY > 0.10 * window.screen.width ? true : false)
      })
    })
  }
  render() {
    return (
      <header>
        <div id="bananas">
          <div className="bananabanner">
            <iframe title="Banana" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" allowtransparency="true" src="https://z.ynet.co.il/short/commerce/2015/links/header/Default.aspx"></iframe>
          </div>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx